/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: af4ab2b4b888d95a1b47f27d4e96e72281e6147a4ee19807a83f189cec255b3d */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRole: build.query<GetRoleApiResponse, GetRoleApiArg>({
      query: (queryArg) => ({
        url: `/roles/Role`,
        headers: {},
        params: {
          roles: queryArg.roles,
        },
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as roles }
export type GetRoleApiResponse = /** status 200 OK */ RoleModel[]
export type GetRoleApiArg = {
  roles?: string[]
}
export type Reference = {
  type?: ReferenceType
  value?: string | null
}
export type RoleModel = {
  /** Describe the prop */
  role?: string | null
  /** Key value pair with relevant information about the role */
  reference?: Reference[] | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export enum ReferenceType {
  ClientId = 'ClientId',
  UnitId = 'UnitId',
}
export const { useGetRoleQuery } = injectedRtkApi
